module.exports = __webpack_public_path__ + "static/media/project-list.1ab43c6c.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/project-list.scss
// module id = 2256
// module chunks = 0